import { FeatureKey, FeatureSettings, PlanType } from "@/types/plans";

export const PLANS: Record<PlanType, Record<FeatureKey, FeatureSettings>> = {
  free: {
    content: {
      isEnabled: true,
      limit: 25,
      features: [],
      message: 'Alcanzaste el límite de creación de platos y bebidas',
    },
    menu: {
      isEnabled: true,
      limit: 1,
      message: 'Alcanzaste el límite de creación de menús',
    },
    survey: {
      isEnabled: true,
      limit: 2,
      message: 'Alcanzaste el límite de creación de encuestas',
    },
    branches: {
      isEnabled: true,
      limit: 1,
      message: 'Alcanzaste el límite de creación de sucursales',
    },
    multimedia: {
      isEnabled: true,
      limit: 50,
      storage: 50,
      message: 'Tu plan permite cargar 50 imágenes ó 50mb lo que suceda primero'
    },
    faq: {
      isEnabled: true,
      limit: 10,
      message: 'Alcanzaste el límite de creación de preguntas frecuentes',
    },
    loyalty: {
      isEnabled: false,
      message: 'Esta función solo está disponible en el Plan Pro',
      features: []
    }
  },
  pro: {
    content: {
      limit: 100,
      features: ['settings', 'scheduling', 'rewards'],
      message: 'Tu plan Pro permite crear hasta 100 platos.',
    },
    menu: {
      isEnabled: true,
      limit: 5,
      message: 'Tu plan permite crear 1 menú.',
    },
    survey: {
      isEnabled: true,
      limit: 10,
      message: 'Alcanzaste el límite de creación de encuestas.',
    },
    branches: {
      isEnabled: true,
      limit: 5,
      message: 'Tu plan permite crear 1 sucursal.',
    },
    multimedia: {
      isEnabled: true,
      limit: 50,
      storage: 50,
      message: 'Tu plan permite cargar 50 imágenes ó 50mb lo que suceda primero'
    },
    faq: {
      isEnabled: true,
      limit: 20,
      message: 'Alcanzaste el límite de creación de preguntas frecuentes',
    },
    loyalty: {
      isEnabled: true,
      message: 'Tu plan Pro permite crear programas de fidelización',
      features: ['rewards']
    }
  },
};